import tap from 'redux-tap';
import toPairs from 'lodash/toPairs';
import { metrics } from '@seek/metrics-js';

const mapToKeyValuePairs = ([key, value]) => `${key}:${value}`;

export default () => {
  const selectMetricsMeta = ({ meta }) => meta && meta.metrics;

  return tap(selectMetricsMeta, (meta) => {
    const { name, tags = {} } = meta;
    const tagPairs = toPairs(tags).map(mapToKeyValuePairs);

    metrics.count('actions', [`action-name:${name}`, ...tagPairs]);
  });
};
